import * as React from "react";
import {
  InfoCardContainer,
  InfoCardText,
} from "../info-card/info-card.emotion";
import { LongCardImage } from "./long-card.emotion";

interface InfoCardProps {
  image?: string;
  leftElement?: React.ReactNode;
  title: string;
  children?: React.ReactNode;
  textWidth?: number;
}

export default function LongCard({
  image,
  leftElement,
  title,
  children,
  textWidth,
}: InfoCardProps) {
  return (
    <InfoCardContainer>
      {image ? <LongCardImage src={image} /> : undefined}
      {leftElement}
      <InfoCardText textWidth={textWidth}>
        <h1>{title}</h1>
        {children}
      </InfoCardText>
    </InfoCardContainer>
  );
}
